module.exports = __webpack_public_path__ + "static/img/img_solution_22.ab6d27c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/msolution/img_solution_22.png
// module id = USU0
// module chunks = 0